"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (regex, str, matchModifier) => {
    let m;
    const matches = [];
    while ((m = regex.exec(str)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }
        m.forEach((match) => {
            if (matchModifier) {
                match = matchModifier(match);
            }
            matches.push(match);
        });
    }
    return matches;
};
